import React from 'react';
import { connect } from 'react-redux';
import GradedSmiley from './GradedSmiley';
import { getStarsJSX } from './redux/FeedbackRedux';

class StatsTableRow extends React.Component {
	render () {
		let AIScore;
		if (this.props.business.AIScore !== undefined) {
			AIScore = this.props.business.AIScore < 50 ? 'text-danger' :
					this.props.business.AIScore < 65 ? 'text-warning' :
					'text-success';
		}

		let color;
		switch (true) {
			case this.props.business.smiley_score >= 85:
				color = '#01de1c';
				break;
			case this.props.business.smiley_score >= 70 && this.props.business.smiley_score < 85:
				color = '#33f502';
				break;
			case this.props.business.smiley_score >= 55 && this.props.business.smiley_score < 70:
				color = '#8cc704';
				break;
			case this.props.business.smiley_score >= 45 && this.props.business.smiley_score < 55:
				color = '#888888';
				break;
			case this.props.business.smiley_score >= 30 && this.props.business.smiley_score < 45:
				color = '#ffcf08';
				break;
			case this.props.business.smiley_score >= 15 && this.props.business.smiley_score < 30:
				color = '#fe0100';
				break;
			case this.props.business.smiley_score >= 0 && this.props.business.smiley_score < 15:
				color = '#b30101';
				break;
			default:
				color = ''; // Handle any other cases as needed
		}

        var difflink = false;
        var base_url = "#";
        if(this.props.business.link_type && this.props.business.link_type == 'business'){
            if(this.props.business.region_id) {
                base_url = "/business/" + this.props.business.business_id + "/feedbacks/" + this.props.state_region.region_type+"/"+this.props.state_region.region_id;
            } else {
                base_url = "/business/" + this.props.business.business_id + "/feedbacks";
            }
        } else if(this.props.business.link_type && this.props.business.link_type == 'businessgroup'){
				base_url = "/business/" + this.props.business.business_id + "/feedbacks";
		} else if (this.props.business.link_type && this.props.business.link_type == 'region'){
            if(this.props.business.region_id) {
                base_url = "/dashboard/region/"+this.props.business.region_id;
                difflink = true;
            }
        } else {
            if(this.props.state_region.region_id){
                base_url = "/business/" + this.props.business.business_id + "/feedbacks/" + this.props.state_region.region_type+"/"+this.props.state_region.region_id;
            } else {
                base_url = "/business/" + this.props.business.business_id + "/feedbacks";
            }
        }

		let business_row_name = <a href={base_url + '?status=Open'}>{this.props.business.businessname}</a>;
		if(this.props.is_super_user){
			business_row_name = <a href={"/view-as-business/login/"+this.props.business.business_id+"/dashboard"}>{this.props.business.businessname}</a>;
		}

		return (
			<tr>
				{this.props.is_super_user && this.props.business.business_group && this.props.business.business_group == "No Business Group" &&
					<td><span className="d-none">ZZZ</span>{this.props.business.business_group}</td>
				}
				{this.props.is_super_user && this.props.business.business_group && this.props.business.business_group != "No Business Group" &&
					<td>{this.props.business.business_group}</td>
				}

				{/* Business Name */}
				<td className="col-1 address">
					{business_row_name}
				</td>

				<td className="col-1"><a href={base_url+'/timeframe/'+this.props.timeframe+'/status/All/other/'+this.props.other}>{this.props.business.open + this.props.business.pending + this.props.business.resolved}</a></td>
				<td className="col-1"><a href={base_url+'/timeframe/'+this.props.timeframe+'/status/Open/other/'+this.props.other}>{this.props.business.open}</a></td>
				<td className="col-1"><a href={base_url+'/timeframe/'+this.props.timeframe+'/status/Pending/other/'+this.props.other}>{this.props.business.pending}</a></td>
				<td className="col-1"><a href={base_url+'/timeframe/'+this.props.timeframe+'/status/Resolved/other/'+this.props.other}>{this.props.business.resolved}</a></td>
				<td className="col-1"><a href={base_url+'/timeframe/'+this.props.timeframe+'/status/RatingsOnly/other/'+this.props.other}>{this.props.business.ratingsOnly}</a></td>
				<td className="col-1"><a href={base_url+'/timeframe/'+this.props.timeframe+'/status/All/other/chats_requested'}>{this.props.business.chats_requested}</a></td>
				
				{/* Chats Started */ }
				<td className="col-1"><a href={base_url+'/timeframe/'+this.props.timeframe+'/status/All/other/chats_started'}>{ this.props.business.chats_started + ((this.props.business.chats_requested != 0 && this.props.business.chats_started <= this.props.business.chats_requested) ? ( parseInt(this.props.business.chats_started / this.props.business.chats_requested * 100) != 0 ? " (" + parseInt(this.props.business.chats_started / this.props.business.chats_requested * 100) + "%)":"") : 0 ) }</a></td>

				{/* Smiley Score */}
				{this.props.business.smiley_score !== null 
					?
						<td className="d-flex col-1" style={{'color':color, 'whiteSpace':'nowrap'}}>
							<GradedSmiley smiley_score={this.props.business.smiley_score} /> {this.props.business.smiley_score}  %
						</td>
					: 
						<td className="col-1">
							{ __('No Data') }
						</td>
				}

				{/* AI Score */}
				<td className={AIScore + " col-1"}>
					{this.props.business.AIScore ? this.props.business.AIScore+"%" : __("No Data")}
				</td>
				
				{/* Median Response Time */}
				<td className="col-1" data-sort={this.props.business.median_response_time.seconds}>
					<span data-time={this.props.business.median_response_time.seconds}>
						{(this.props.business?(this.props.business.median_response_time !== 0 
							? this.props.business.median_response_time.formatted 
							: "No Data"):"No Data")}
					</span>
				</td>
				
				{/* Stars */}
				<td className="col-1" data-sort={this.props.business.avg_ratethisbiz}>
					<span data-time={this.props.business.avg_ratethisbiz}>
					{this.props.business
						? (this.props.business.avg_ratethisbiz !== null && this.props.business.avg_ratethisbiz !== 0)
							? <span>{this.props.business.avg_ratethisbiz.toFixed(2)}<br/>{getStarsJSX(this.props.business.avg_ratethisbiz, "OTF", true)}</span>
							: "No Data"
						: "No Data"}
					</span>
				</td>
			</tr>
		);
	}
}

function mapStateToProps(state) {
	return {is_super_user:state.is_super_user??null, timeframe: state.timeframe, status: state.status, other: state.other_filter, state_region: (state.region && state.region_type ? {region_type: state.region_type, region_id: state.region.id} : null) }
}

export default connect(mapStateToProps)(StatsTableRow);
